import React from 'react'
import { Icon } from 'antd'

import {
  formatCount,
  getGeneratedAssets,
  getPhaseCount,
  getPhaseView,
  getStoryboardPlanCount,
  isEntityVerified,
  isStoryboardPlanApproved
} from '../../utils'
import './PhaseSummaryCard.scss'

const getPhaseSummary = ({ phase, phaseData, isFinalized }) => {
  const phasePayload = phaseData[phase] || {}
  const assets = getGeneratedAssets(phaseData, phase)
  const count = getPhaseCount(phaseData, phase)

  if (phase === 'storyboard') {
    const plannedShots = getStoryboardPlanCount(phasePayload.plan)
    const planApproved = isStoryboardPlanApproved(phaseData)

    if (assets.length) {
      return `${formatCount(assets.length)} storyboard visual${
        formatCount(assets.length) === 1 ? '' : 's'
      } generated`
    }

    if (plannedShots) {
      return `${formatCount(plannedShots)} planned shot${
        formatCount(plannedShots) === 1 ? '' : 's'
      }${planApproved ? ' approved' : ' ready for review'}`
    }

    return 'Shot plan not extracted yet'
  }

  if (phase === 'finalized') {
    return isFinalized ? 'Creative guideline ready' : 'Waiting for finalization'
  }

  if (assets.length) {
    return `${formatCount(assets.length)} visual${
      formatCount(assets.length) === 1 ? '' : 's'
    } generated`
  }

  if (count) {
    const entities = phasePayload.entities || []
    const verifiedCount = entities.filter(isEntityVerified).length
    return `${formatCount(count)} item${
      formatCount(count) === 1 ? '' : 's'
    } found · ${formatCount(verifiedCount)} verified`
  }

  return 'Not started'
}

const PhaseSummaryCard = ({ phase, phaseData, isFinalized }) => {
  const view = getPhaseView(phase)
  const summary = getPhaseSummary({ phase, phaseData, isFinalized })

  return (
    <section className="creative-direction-chat__phase-summary">
      <div className="creative-direction-chat__phase-summary-icon">
        <Icon type={view.icon} />
      </div>
      <div className="creative-direction-chat__phase-summary-content">
        <span>{view.label}</span>
        <strong>{summary}</strong>
      </div>
    </section>
  )
}

export default PhaseSummaryCard
